import { Box, CircularProgress, Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLoadingBlockerMessage } from '../../redux/hooks/LoadingBlockerHook';

export const LoadingBlockerModal = () => {
  const loadingMessage = useLoadingBlockerMessage();

  const [lastVisibleLoadingMessage, setLastVisibleLoadingMessage] =
    useState(loadingMessage);
  const isDisplayed =
    loadingMessage !== null && lastVisibleLoadingMessage !== null;

  useEffect(() => {
    if (loadingMessage) setLastVisibleLoadingMessage(loadingMessage);
  }, [loadingMessage]);

  return (
    <Dialog
      open={isDisplayed}
      onClose={() => {
        /* Prevent close. */
      }}
      maxWidth={'xs'}
      fullWidth
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 6,
        }}
      >
        <CircularProgress size={64} />
        <p>{lastVisibleLoadingMessage ?? ''}</p>
      </Box>
    </Dialog>
  );
};
